import BannerQueueModal from './BannerQueueModal';

export default BannerQueueModal;